import { isRolesUiEnabled, permissionGuard } from '@tundr/permissions';
import type { NavigationGuardNext, NavigationGuardWithThis } from 'vue-router';
import { useCreateHrStore } from '../store/create-hr.store.ts';
import { HR_ROLES_WRITE_PERMISSION } from '../utils/hr-permissions.ts';
import { hrRoutesDictionary } from './hr-routes.dictionary.ts';

const rolesWritePermissionGuard = permissionGuard(HR_ROLES_WRITE_PERMISSION, {
  redirect: { name: hrRoutesDictionary.hr.list.name },
});

const noopNext: NavigationGuardNext = () => undefined;

// Guards that declare `next` (arity 3) must call it: vue-router ignores their
// return value, leaving the navigation pending forever.
export const roleUiPermissionGuard: NavigationGuardWithThis<undefined> =
  function (to, from) {
    if (!isRolesUiEnabled()) {
      return { name: hrRoutesDictionary.hr.list.name };
    }
    return rolesWritePermissionGuard.call(this, to, from, noopNext);
  };

export const createRoleDataGuard: NavigationGuardWithThis<undefined> = () => {
  const createHrStore = useCreateHrStore();
  return createHrStore.hasAnagraphicData
    ? true
    : { name: hrRoutesDictionary.hr.create.name };
};
